export default class TranscriptComponentState {
  filterText: string = "";
  transcriptContainerClassName: string = '';
}
